import config from '../Config';

export const shouldFixModuleRendering = (componentWidth: number) => {
  return config.isModule && componentWidth < 600;
};
